import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DatepickerService {
  year = new BehaviorSubject<number>(new Date().getFullYear())
  month =new BehaviorSubject<number>(new Date().getMonth())
  days!: any[]
  constructor() { }
  
  public changeMonth(month:number, year?:number){
    this.month.next(month);
    if(year){
      this.year.next(year);
    }
  }

  public generateDays(year: number, month: number) {
    
    const increment = this.getIncrement(year, month)
    const days: any = [];
    [0, 1, 2, 3, 4, 5,].forEach((x, index) => {
      days.push([])
      for (let y = 0; y < 7; y++) {
        const date = this.getDate(x, y, year, month, increment)
        days[index].push(date)
      }
    })
    return days
  }

  public getIncrement(year: number, month: number): number {
    let date = new Date(year + "-" + (month+1) );
    let increment = date.getDay() > 0 ? date.getDay()-1 : 6;
    return increment;
  }

  public getDate(
    week: number,
    dayWeek: number,
    year: number,
    month: number,
    increment: number
  ) {
    let date: any;
    let day = week * 7 + dayWeek - increment;
    if (day <= 0) {
      let fechaAuxiliar = new Date(year + "-" + (month+1) );
      date = new Date(
        fechaAuxiliar.getTime() + (day - 1) * 24 * 60 * 60 * 1000
      );
    } else {
      date = new Date(year + "-" + (month+1)+ "-" + day);
      if (isNaN(date.getTime())) {
        let fechaAuxiliar = new Date(year + "-" + (month+1) )
        date = new Date(
          fechaAuxiliar.getTime() + (day - 1) * 24 * 60 * 60 * 1000
        );  
      }
    }
    return {
      dateTxt: date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2),
      date: date,
      day: date.getDate(),
      // isMonth: date.getMonth() == month -1
      isMonth:this.status(date,month),
      time:date.getTime()
    };
  }
  status(date:any,month:any){
    if( month>0&&month<11){
      if(date.getMonth() == month -1) return false
      if(date.getMonth() == month +1) return false
      return true;
    }else{
      if(month==0||month==11)if(!(date.getMonth() == month)) return false
      return true;
    }
  }

  getClassName(classname: any) {
    let className = '';
      if (classname) {
        if (typeof classname === 'string') {
          className = classname;
        } else {
          className = classname.join(' ');
        }
      }
    return className;
  }

}
